import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
} from '@angular/core';
import { AccordeonItemContentComponent } from '../accordeon-item-content/accordeon-item-content.component';
import { AccordeonItemHeaderComponent } from '../accordeon-item-header/accordeon-item-header.component';

@Component({
  selector: 'lib-accordeon-item[value]',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordeonItemComponent {
  @Input() value!: any;

  @Input() imgSrc: string | undefined;

  @Input() imgSrc2?: string | undefined;

  @ContentChild(AccordeonItemHeaderComponent)
  public header!: AccordeonItemHeaderComponent;

  @ContentChild(AccordeonItemContentComponent)
  public content!: AccordeonItemContentComponent;
}
